export const conversationsPath = '/conversations'
export const userConversationsPath = '/public/conversations/'
export const ideationPublicPath = '/empower/ideation/'
export const ideationDraftPath = '/empower/draft/'
export const adminAppURL = process.env.REACT_APP_ADMIN_URL
